import type { FunctionComponent, SVGProps } from "react";

import type { TranslationKey } from "src/types/translationKey";

import {
  IconMacroCarbs,
  IconMacroFat,
  IconMacroFiber,
  IconMacroProtein
} from "./MacroIcons";

export interface MealInsightNutrients {
  protein?: number;
  fiber?: number;
  totalFats?: number;
  totalCarbohydrates?: number;
}

export interface MacroConfig {
  nutrient: keyof MealInsightNutrients;
  label: TranslationKey;
  color: string;
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
}

export const MEAL_MACROS: MacroConfig[] = [
  {
    nutrient: "protein",
    label: "mealInsights.nutrition.protein",
    color: "#aa6533",
    Icon: IconMacroProtein
  },
  {
    nutrient: "fiber",
    label: "mealInsights.nutrition.fiber",
    color: "#0e843a",
    Icon: IconMacroFiber
  },
  {
    nutrient: "totalFats",
    label: "mealInsights.nutrition.totalFats",
    color: "#907050",
    Icon: IconMacroFat
  },
  {
    nutrient: "totalCarbohydrates",
    label: "mealInsights.nutrition.totalCarbs",
    color: "#905c81",
    Icon: IconMacroCarbs
  }
];

export const CALORIES_ICON_COLOR = "#ca4727";
